import { UserInput } from "../../http/protocol";
import { UseFormRegister } from "react-hook-form/dist/types/form";
import {
  FieldErrors,
  FieldErrorsImpl,
} from "react-hook-form/dist/types/errors";
import { RegisterOptions } from "react-hook-form/dist/types/validator";
import { formText } from "../user-utils";
import { InputError } from "./InputError";
import * as React from "react";
import { Merge } from "react-hook-form";
import { Checkbox } from "../../ui/notifications/NotificationsComponent";
import { t } from "../../i18n";

interface Props {
  input: UserInput;
  name: string;
  register: UseFormRegister<any>;
  errors: FieldErrors<any>;
  options?: RegisterOptions;
  handleFocus: any;
}

export const UserDetailsPromoCodeInput = ({
  name,
  register,
  errors,
  options,
  handleFocus,
}: Props) => {
  const [showInput, setShowInput] = React.useState(false);

  let hasError = false;
  if (name.startsWith("attributes.") && errors.attributes) {
    let attributeName = name.replaceAll("attributes.", "");
    const errorsAttributes = errors.attributes as
      | keyof FieldErrors
      | Merge<FieldErrors, FieldErrorsImpl<any>>;
    hasError = !!errorsAttributes[attributeName as any];
  } else {
    hasError = !!errors[name];
  }

  const { nameText, invalidText, helpText, placeholder } = formText(name);
  return (
    <div
      onBlur={handleFocus}
      className={"form-group " + (hasError ? "has-error" : "")}
    >
      <div style={{marginBottom: ".7rem"}}>
        <label id={name} className={"forms-label"} htmlFor={name}>
          <Checkbox
            checked={showInput}
            onChange={(e) => setShowInput(e?.target.checked ?? false)}
          />
          {t("forms.promoCode.label")}
        </label>
      </div>
      {showInput && (
        <>
          {nameText && nameText.length > 0 && (
            <label id={name} className={"forms-label"} htmlFor={name}>
              {nameText}
            </label>
          )}
          <input
            onFocus={handleFocus}
            placeholder={placeholder}
            className={"form-control testos"}
            {...register(name, options)}
          />
          {helpText.length > 0 && !hasError && (
            <span className="help-block">{helpText}</span>
          )}
          {hasError && (
            <InputError name={name} errors={errors} invalidText={invalidText} />
          )}
        </>
      )}
    </div>
  );
};
